import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the PrizeLevelModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-prize-level-modal',
  templateUrl: 'prize-level-modal.html',
})
export class PrizeLevelModalPage {
  pll : any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.pll = this.navParams.get('prizedata');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PrizeLevelModalPage');
  }

  goBack() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/app/lottery/prize-level-modal/prize-level-modal.ts